/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'television-play': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5a2 2 0 002-2V5a2 2 0 00-2-2m0 14H3V5h18m-5 6l-7 4V7"/>'
  }
})
